import React, { useEffect, useState ,useContext} from "react";
import projectService from "../../services/api/projects-service";
import jwplayerService from "../../services/api/jwplayer-service";
import {useHistory} from "react-router-dom";
import Pagination from "react-js-pagination";
import ReactBSAlert from "react-bootstrap-sweetalert";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPencilAlt, faTrash,faTablet,faTrashRestoreAlt } from '@fortawesome/free-solid-svg-icons'
import UserContext from "../../UserContext";
import Moment from "react-moment";
import generalHelper from '../../variables/general-helper.js';
// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Label,
  FormGroup,
  Form,
  Input,
  Alert,
  Spinner,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Table,
  Container,
  Row,
  Col,
} from "reactstrap";

import Select from "react-select";
import '../projects/Projects.css'
const JwplayerProjects = (props)=> {
  const history = new useHistory(); 
  const context = useContext(UserContext);
  const [formdetails, setFormDetails] = useState({publisherids:[],publishername:'',publisheremail:'',projectname:'',status:0});
  const [projects, setProjects] = useState(false);
  const [totalProjects,setTotalProjects] = useState(0);
  const [activePage,setActivePage] = useState(1);
  const [renderComponent, setRenderComponent] = useState(false);
  const [search,setSearchDetails] = useState({publisherids:[],publishername:'',publisheremail:'',projectname:'',status:0});
  const [allPublishers, setAllPublishers] = useState([]);
  const [showPopup,setShowPopup] = useState({alert:null});
  const [reloadComponent,setReloadComponent] = useState(0);
  const records = 10;
  let map = new Map();
  let statusArray = [
    {
      value: 0,
      label: "All",
    },
    {
      value: 1,
      label: "Active",
    },
    {
      value: -1,
      label: "Inactive",
    },
    
    
  ];
  const pathname = window.location.href;

  useEffect(()=>{
    let filtersJSONString= generalHelper.getValueFromQueryString("filters");
    if(filtersJSONString){
      try{
        let filters = JSON.parse(filtersJSONString);
        setFormDetails({...formdetails,...filters});
      }catch(error){
        setFormDetails({publisherids:[],publishername:'',publisheremail:'',projectname:'',status:0});
      }
    }else{
      setFormDetails({publisherids:[],publishername:'',publisheremail:'',projectname:'',status:0});
    }
    let pageNumber = new URLSearchParams(window.location.search).get("page");
    if(pageNumber){
      setActivePage(pageNumber);
    }
    else{
      pageNumber=1;
      generalHelper.addKeyToQueryString("page",1);
    }
    setActivePage(pageNumber);
    setSearchDetails({});
},[pathname]);
  useEffect( () => {
    (async () =>{
      let publishers = await projectService.getAllPublishers();
    
      if(!publishers.status && publishers.error.errorCode === 403){
        let newurl = window.location.protocol + "//" + window.location.host + "/dashboard/home"
        window.history.replaceState({},'',newurl)
      }
        if(publishers.status){
            let getPublishers = [];
            let publisherData = publishers.data;
            if(publisherData.length){
                publisherData.forEach(function(publisherDetails) {
                    let publisherValue = {value:publisherDetails.id,label:publisherDetails.name+"("+publisherDetails.email+")"};
                    getPublishers.push(publisherValue)
                  })
                }
                setAllPublishers(getPublishers);
              }
              
              
              
            })();
          }, []);
          
          
          useEffect( () => {
    (async () =>{
          let getIds = [];
            let projectsData = await jwplayerService.getAllJwplayerProjectsData(formdetails,activePage,records);
         
          // projectsData.data.map((e)=>{
            //   getIds.push(e.id)
            // })

            // console.log("ids are :::",getIds)
            // let allActiveJwplayerprojects = await projectService.getAllActiveJwplayerProjects(getIds);

            if(!projectsData.status && projectsData.error.errorCode === 403){
              let newurl = window.location.protocol + "//" + window.location.host + "/dashboard/home"
              window.history.replaceState({},'',newurl)
            }
            if(projectsData.status && projectsData.data){
                // console.log("ProjectData",projectsData);
               
                setProjects(projectsData.data.allProjects.projects);
            }
            
          // let getTotalProjects = await projectService.getTotalProjectsForJwplayer(formdetails);

            

           
        
          setTotalProjects(projectsData.data.allProjects.allProjects.length);
            // if(getTotalProjects.status){
            // }

            
              setRenderComponent(true);
            

        })();
    }, [activePage,search,reloadComponent]);

    const suspendProjectPopup = (projectId) => {
      setShowPopup({
        alert: (
          <ReactBSAlert
            warning
            style={{ display: "block", marginTop: "-100px" }}
            title="Are you sure?"
            onConfirm={() => suspendProject(projectId)}
            onCancel={() => hideAlert()}
            confirmBtnBsStyle="info"
            cancelBtnBsStyle="danger"
            confirmBtnText="Yes, Suspend this!"
            cancelBtnText="Cancel"
            showCancel
            btnSize=""
          >
            You want to suspend this project!
          </ReactBSAlert>
        ),
      });
    }

    const restoreProjectPopup = (projectId) => {
      setShowPopup({
        alert: (
          <ReactBSAlert
            warning
            style={{ display: "block", marginTop: "-100px" }}
            title="Are you sure?"
            onConfirm={() => restoreProject(projectId)}
            onCancel={() => hideAlert()}
            confirmBtnBsStyle="info"
            cancelBtnBsStyle="danger"
            confirmBtnText="Yes, restore it!"
            cancelBtnText="Cancel"
            showCancel
            btnSize=""
          >
            You want to restore this project again!
          </ReactBSAlert>
        ),
      });
    }

    const suspendProject = async (projectId) => {
      let susProject = await projectService.suspendProject(projectId);
      if(!susProject.status && susProject.error.errorCode === 403){
          setShowPopup({
            alert:null
          });
          context.setIsAuthorized(context);
      }
      else if(susProject.status && susProject.data.deleted){
        setShowPopup({
          alert: (
            <ReactBSAlert
              success
              style={{ display: "block", marginTop: "-100px" }}
              title="Removed!"
              onConfirm={() => hideAlert()}
              onCancel={() => hideAlert()}
              confirmBtnBsStyle="info"
              btnSize=""
            >
              Project was suspended successfully.
            </ReactBSAlert>
          ),
        });
          setReloadComponent(Math.random());
      }else{
        setShowPopup({
          alert: (
            <ReactBSAlert
              danger
              style={{ display: "block", marginTop: "-100px" }}
              title="Please try again!"
              onConfirm={() => hideAlert()}
              onCancel={() => hideAlert()}
              confirmBtnBsStyle="info"
              btnSize=""
            >
              Project could not be suspended. Please try again.
            </ReactBSAlert>
          ),
        });
      }
    }

    const restoreProject = async (projectId) => {
      let resProject = await projectService.restoreProject(projectId);
      if(!resProject.status && resProject.error.errorCode === 403){
          setShowPopup({
            alert:null
          });
          context.setIsAuthorized(context);
      }
      else if(resProject.status && resProject.data.restored){
        setShowPopup({
          alert: (
            <ReactBSAlert
              success
              style={{ display: "block", marginTop: "-100px" }}
              title="Restored!"
              onConfirm={() => hideAlert()}
              onCancel={() => hideAlert()}
              confirmBtnBsStyle="info"
              btnSize=""
            >
              Project was restored successfully.
            </ReactBSAlert>
          ),
        });
        setReloadComponent(Math.random());
      }else{
        setShowPopup({
          alert: (
            <ReactBSAlert
              danger
              style={{ display: "block", marginTop: "-100px" }}
              title="Please try again!"
              onConfirm={() => hideAlert()}
              onCancel={() => hideAlert()}
              confirmBtnBsStyle="info"
              btnSize=""
            >
              Project could not be restored. Please try again.
            </ReactBSAlert>
          ),
        });
      }
    }

    const hideAlert = () => {
      setShowPopup({
        alert: null,
      });
    }; 

  const handlePageChange = (pageNumber) => {
      generalHelper.addKeyToQueryString("page",pageNumber);
      setActivePage(pageNumber);
  }

  const handlePublisherChange = (value) => {
    let publisherIds = [];
    if(value && value.length > 0){
      value.forEach(function(publisherIdDetails){
        publisherIds.push(publisherIdDetails.value);
      })
    }
    setFormDetails({
      ...formdetails,
      publisherids: publisherIds,
    });
  }

  const handleChange = (event) => {
    setFormDetails({
      ...formdetails,
      [event.target.id] : event.target.value
    });
  }

  const handlePublisherNameChange = (event) => {
    setFormDetails({
      ...formdetails,
      publishername: event.target.value,
    });
  }

  const handlePublisherEmailChange = (event) => {
    setFormDetails({
      ...formdetails,
      publisheremail: event.target.value,
    });
  }

  const handleSubmit = function(e){  searchProjects();e.preventDefault() }

  const searchProjects = () => {
      generalHelper.addKeyToQueryString("filters",JSON.stringify(formdetails));
      setActivePage(1);
      setSearchDetails(formdetails);
  }
  const changeStatus = (event) => {
    setFormDetails({
      ...formdetails,
      status: event.value,
    });
  };
  const resetElements = () => {
    document.getElementById('projectname').value = '';
    document.getElementById('projectslug').value = '';
    document.getElementById('publishername').value = '';
    document.getElementById('publisheremail').value = '';
    let defaultFormDetails = {publisherids:[],publishername:'',publisheremail:'',projectname:'',projectslug:'',status:0};
    let jsonString = JSON.stringify({
      ...formdetails,
      ...defaultFormDetails
    });
    generalHelper.addKeyToQueryString("filters",jsonString);
    generalHelper.addKeyToQueryString("page",1);
    setFormDetails({publisherids:[],publishername:'',publisheremail:'',projectname:'',projectslug:'',status:0});
    setSearchDetails({publisherids:[],publishername:'',publisheremail:'',projectname:'',projectslug : '',status:0});

  }

  const redirectProjectUrl = (e,navigate,redirectPath,projectId) =>{
    e.preventDefault()
    history.push("/"+navigate+"/"+redirectPath+"?projectid="+projectId)
  }
  
  let projectElements = [];
  let firstRecord = 0;
  let lastRecord  = 0;
  if(!projects || !projects.length){
    if(!renderComponent){
      projectElements.push(
        <td colSpan="6" className="text-center">
            <Spinner animation="border" role="status">
                    <span className="sr-only">Loading...</span>
                  </Spinner>
        </td>
      );
    }else{
    projectElements.push(
        <td colSpan="7" className="text-center">
            <CardTitle tag="h4">No Projects found.</CardTitle>
        </td>
    );
    }
  }else{
      let i=1;
      projects.forEach(function(projectDetails) {
       
        let className = '';
        if(i==1){
          firstRecord = (activePage-1)*records+i;
        }

          if(projectDetails.status==-1){
            className = 'table-warning';
          }
        
        projectElements.push(
          <>
            <tr style={{height:'100px'}} id={"row_"+projectDetails.project_id._id} >
              
               <td className="text-left">{(activePage-1)*10+i}</td>
               
               <td className="text-left">
                   {projectDetails.project_id.name}
               </td>
               <td>
               <a title="Site Id" onClick={(event)=> {redirectProjectUrl(event,'project','settings',projectDetails.project_id._id) }} class="btn-rotate nav-link" style={{cursor:'pointer'}}>
                  {projectDetails.site_id}
                  </a>
               </td>
             
               <td className="text-left">
                   {projectDetails.project_id.publishers_id.name}
               </td>
               <td  className="text-left">
                   {projectDetails.project_id.publishers_id.email}
               </td>
               
               <td className="text-left">
               {projectDetails.enablejwplayer?"Active":<span style={{color:'red'}}>Inactive</span>} 
               </td>
               <td className="text-left">
                            <Moment format="DD MMM YYYY hh:mm:ss a">
                                {projectDetails.updatedAt}
                            </Moment>
               </td>
              
              
                </tr>
                         
               
               </>

        )
        if(i==projects.length){
          lastRecord = (activePage-1)*records+i;
        }
        i++;
        if(i==projects.length){
          lastRecord = (activePage-1)*records+i;
        }
    })
  }

  
    return (
      <div className="content">
        {showPopup.alert}
        <Container>
          <Row>
          <Col className="ml-auto mr-auto"  md="12">
              <Card className="card-signup text-center">
                <CardHeader>
                
                <CardTitle tag="h4">
                   JW Player Projects 
                </CardTitle>
                <Form id="projectfilters" action="" className="form" method="POST" onSubmit={handleSubmit}>
                  {/* <Col md="4">
                  <Select
                    className="react-select primary"
                    classNamePrefix="react-select"
                    placeholder="select publishers"
                    name = "publisherids"
                    id="publisherids"
                    isMulti = "true"
                    options={allPublishers}
                    onChange={(value)=>  handlePublisherChange(value) }
                  />
                  </Col> */}
                  <Row>
                  <Col sm="3">
                  <Input type="text" name="publishername" id="publishername" value={formdetails.publishername} onChange={handlePublisherNameChange} placeholder="Publisher Name .."/>
                  </Col>
                  <Col sm="2">
                  <Input type="text" name="publisheremail" id="publisheremail" value={formdetails.publisheremail} onChange={handlePublisherEmailChange} placeholder="Publisher Email .."/>
                  </Col>
                  <Col sm="2">
                  <Input type="text" name="projectname" id="projectname" value={formdetails.projectname} onChange={handleChange}  placeholder="Project Name .."/>
                  </Col>
                  <Col sm="2">
                  <Input type="text" name="projectslug" id="projectslug" value={formdetails.projectslug} onChange={handleChange}  placeholder="Site Id .."/>
                  </Col>
                  <Col sm="3">
                  <Select
                        className="react-select primary"
                        classNamePrefix="react-select"
                        placeholder="Select Status .."
                        name="status"
                        id="status"
                        options={statusArray}
                        value={formdetails.status!==""?statusArray.filter(option=> option.value === formdetails.status):""}
                        onChange={changeStatus}
                      />
                  </Col>
                  </Row>
                  <Row>
                  <Col md="12">
                    <div style={{'float':'left'}}>
                    <Button
                      className="btn-round"
                      //style={{'margin-top':'-5px'}}
                      color="info"
                      type="submit"
                      //onClick={searchProjects}
                    >
                      Search
                    </Button>
                    <Button
                      className="btn-round"
                      //style={{'margin-top':'-5px'}}
                      color="warning"
                      type="button"
                      onClick={resetElements}
                    >
                      Reset
                    </Button>
                    </div>
                  </Col>
                </Row>
                </Form>
                <hr></hr>
                {totalProjects > 0 ? 
                  <Row>
                    
                    <Col md="6">
                      <div style={{float:'right',margin:'5px'}}>
                        <b>{firstRecord} - {lastRecord} of {totalProjects}</b>
                      </div>
                    </Col>
                    <Col md="6">
                    <div style={{float:'left'}}>
                        <Pagination
                        activePage={activePage}
                        itemsCountPerPage={records}
                        totalItemsCount={totalProjects}
                        pageRangeDisplayed={3}
                        onChange={handlePageChange.bind(this)}
                        itemClass="page-item"
                        linkClass="page-link"
                        />
                    </div>
                  </Col>
                  </Row>
                : null}
                 
                </CardHeader>
                <CardBody>
                <Table class="fixed" responsive>
                    <thead className="text-primary">
                      <tr>
                      <th className="text-left">#</th>   
                        <th className="text-left">Project Name</th>
                       
                        <th className="text-left" >Site Id</th>
                        <th className="text-left" >Publisher Name</th>
                        <th className="text-left" >Publisher Email</th>
                        <th className="text-left">Status</th>
                        <th className="text-left">Last updated At</th>
                        {/* <th className="text-left">Stats</th> */}
                        {/* <th className="text-left">Action</th> */}
                      </tr>
                    </thead>
                    <tbody>{projectElements}</tbody>
                  
                  </Table>
                </CardBody>
                <CardFooter>
                
                </CardFooter>
              </Card>
            </Col>
          </Row>
        </Container>
        <div
          className="full-page-background"
          style={{
            backgroundImage: `url(${require("../../assets/img/bg/jan-sendereks.jpg")})`,
          }}
        />
      </div>
    );
  
  
}

export default JwplayerProjects;
